import { createContext } from "react";

import type { EmptyStateVariants } from "../empty-state.types";

export const EmptyStateContext = createContext<{
  size?: EmptyStateVariants;
}>({
  size: "wide",
});
